import React, { Component } from 'react';
import '../StoreSelector.css';
import './NewStoreSelector.css';
import { setCursorStyle } from '../../../../utils/MouseUtilities.js';
import Segment from 'semantic-ui-react/dist/es/elements/Segment';
import 'semantic-ui-css/components/segment.min.css';
import 'semantic-ui-css/components/image.min.css';
import { Accordion, Icon } from 'semantic-ui-react';

const hoverCursorStyle = 'pointer';
const unhoverCursorStyle = 'all-scroll';

import { MapSectionClicked } from '../../../../utils/Analytics.js';

import { getAllSceneInfoDictAsync } from '../../../../utils/StoreConfigManager';
import { AppContext } from '../../../../AppContext.jsx';
import { ThreeJSWorldContext } from 'web-store-modules/packages/web-store-three-world';
import { getCurrentScene } from '../../../../utils/History';
const variables = require('../../../../../../variables/Variables.js');

const dropDownArrowIcon = "https://cdn.obsess-vr.com/fendi/new-expand-arrow.png"

import { getFloorMenu } from '../../../../utils/StaticAssetManager';
import FloorPin from './FloorPin';

const mainSections = [
    '5f1b7c4fd0b1a90e118090b1',
    '5f1b869fd0b1a90e118090c1',
    '5f1f49b0d0b1a90e118090eb',
]
const sectionData = getFloorMenu()

class CurrentStoreFloorMenuItem extends Component {
    constructor(props) {
        super(props);

        this.onHover = this.onHover.bind(this);
        this.onUnhover = this.onUnhover.bind(this);
        this.onClick = this.onClick.bind(this);

        this.state = {
            jumpToFont: 'https://s3.amazonaws.com/obsessvr-webstore-assets-public/Caslon-BookItalic.otf',
            placeholderIconSrc: 'https://s3.amazonaws.com/obsessvr-webstore-assets-public/placeholder.svg',
            currentStoreMenuItemColor: '#7d7e7e',
            sections: sectionData,
            activeIndex: 0,
        }

    }

    onHover() {
        setCursorStyle(hoverCursorStyle);
    }

    onUnhover() {
        setCursorStyle(unhoverCursorStyle);
    }

    onClick(sceneId) {
        const { threeJSWorldContext, setLoadingIconVisibility, closeMenu, setCurrentScene } = this.props;
        setLoadingIconVisibility(true);
        closeMenu();
        getAllSceneInfoDictAsync()
            .then(sceneInfoDict => {
                if (!sceneInfoDict[sceneId]) {
                    throw new Error('Scene with id ' + sceneId + ' do not exist!');
                }
                const linkedSceneName = sceneInfoDict[sceneId]['name'];
                let targetPath = '/' + linkedSceneName;
                // StoreSelectorOption(linkedSceneName);
                MapSectionClicked(linkedSceneName);
                setCurrentScene(sceneId)
                if (threeJSWorldContext.history.location.pathname !== targetPath) {
                    threeJSWorldContext.pushHistoryWithReset(targetPath)
                } else {
                    this.props.setLoadingIconVisibility(false);
                }
            })
    }

    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index
        this.setState({ activeIndex: newIndex })
    }

    render() {

        const { currentStoreMenuItemColor, placeholderIconSrc, sections, activeIndex } = this.state;
        const { menuTextFontStyle, store, currentScene, itemType } = this.props;
        let style = Object.assign({}, menuTextFontStyle);
        style.color = currentStoreMenuItemColor;
        const routeRenders = sectionData.map((scene, index) => (
            <Accordion key={index}>
                <React.Fragment key={index}>
                    {scene.isHeader ?
                        <Accordion.Title
                            active={activeIndex === index}
                            index={index}
                            onClick={this.handleClick}
                            style={{ width: '115%' }}
                        >
                            <li className='linked-store-scene' onClick={() => scene.sceneId && !scene.haveItems && this.onClick(scene.sceneId)}>
                                <span
                                    className={(currentScene === scene.sceneId && scene.sceneId != '' ? 'active-section' : '')}
                                    onMouseOver={this.onHover}
                                    onMouseOut={this.onUnhover}
                                    onClick={() => scene.sceneId && this.onClick(scene.sceneId)}
                                > {scene.name}</span>
                                {scene.haveItems ?
                                    <img src={dropDownArrowIcon}
                                        className="dropdown-arrow-style"
                                        style={{ transform: activeIndex === index ? 'rotate(360deg)' : '' }} /> : ''
                                }
                            </li>
                        </Accordion.Title>
                        : ""
                    }
                    {scene.submenu &&
                        scene.submenu.map((item, i) => {
                            return (
                                <Accordion.Content active={activeIndex === index}>
                                    <li className='floor-store-image' >
                                        <div style={{ position: 'relative' }}>
                                            <div className="pins">
                                                {item.pins.map((element, j) => {
                                                    return (
                                                        <FloorPin
                                                            key={element.sceneId}
                                                            isActive={currentScene === element.sceneId}
                                                            sceneName={element.name}
                                                            sceneId={element.sceneId}
                                                            handleClick={this.onClick}
                                                            x={element.x}
                                                            y={element.y}
                                                        />
                                                    )
                                                })
                                                }
                                            </div>
                                            <img src={item.imageUrl} style={{ width: "100%", minWidth: item.name == '1' ? '19rem' : '100%' }} />
                                        </div>
                                    </li>
                                </Accordion.Content>
                            )
                        })
                    }
                </React.Fragment>
            </Accordion>
        ));

        return (
            <Segment className="overflow-auto">
                <ul className="selector">
                    {routeRenders}
                </ul>
            </Segment>
        );
    }
}

CurrentStoreFloorMenuItem.propTypes = {
    closeMenu: PropTypes.func,
    menuTextFontStyle: PropTypes.object,
    store: PropTypes.object,
    setLoadingIconVisibility: PropTypes.func,
    selectedScene: PropTypes.string
};

export default props => (
    <AppContext.Consumer>
        {appContextValue => (
            <ThreeJSWorldContext.Consumer>
                {threeJSWorldContext => (
                    <CurrentStoreFloorMenuItem
                        {...props}
                        threeJSWorldContext={threeJSWorldContext}
                        setLoadingIconVisibility={appContextValue.setLoadingIconVisibility}
                        setCurrentScene={appContextValue.setCurrentScene}
                        currentScene={appContextValue.currentScene}
                    />
                )}
            </ThreeJSWorldContext.Consumer>
        )}
    </AppContext.Consumer>
);
